export default __webpack_public_path__ + "static/media/ic-dl-question-bank.a3e13da0.svg";